import React from 'react';
import { Link } from 'react-router-dom';
import NavBar from './NavBar';
import SideBar from './SideBar';
import UserProfileMenu from '../UserProfileMenu/UserProfileMenu';
import './Menu.css';

function Menu() {
    return (
        <div className="flex flex-col h-screen w-full max-w-[18vw] shrink-0 menu-shell">
            <NavBar />
            <div className="bg-white flex justify-center items-center py-4 px-[1vw] border-b border-blue-200">
                <Link to="/" className="flex items-center no-underline">
                    <img
                        src="/img/neuratrader_logo.png"
                        alt="Logo"
                        className="w-[clamp(100px,7.5vw,150px)] h-auto max-h-[150px] object-contain"
                    />
                </Link>
            </div>
            <div className="menu-profile-slot">
                <UserProfileMenu variant="sidebar" showHomeLink />
            </div>
            <SideBar />
        </div>
    );
}

export default Menu;
